import React from "react";
import ReactDOM from "react-dom";

import { observer, inject, Provider } from "mobx-react";
import { extendObservable } from 'mobx';

import { Link } from "react-router-dom";


@inject('core')
@observer
export default class Filter extends React.Component {
	
	constructor(props) {
		super(props)
		this.updateFilter      = this.updateFilter.bind(this)
		this.keyPress          = this.keyPress.bind(this)
		this.clickActionButton = this.clickActionButton.bind(this)
	}
	
	componentDidMount() {
		const { core } = this.props
		this.filterInput.focus()
	}
	
	updateFilter(e) {
		core.updateProductFilter(e.target.value)
	}
	
	keyPress(e) {
		//console.log(e.key, e.keyCode)
		switch(e.key) {
			case 'Escape': 
				core.updateProductFilter('')
				break;
				
			case 'Enter':
				this.clickActionButton()
				break;
		}
	}
	
	clickActionButton() {
		const { core } = this.props

		const hits = core.products.filter(p => {
			if (!core.productFilter) return true
			return p.name.toLowerCase().indexOf(core.productFilter.toLowerCase()) >= 0
		})	
		
		if (hits.length == 0) {
			const uuid = core.uuid('p')
			core.action({
				op:'addProduct', 
				product_id: uuid, 
				name: core.productFilter
			})
		}
		else if (hits.length == 1) {
			const needs = hits[0].needs
			core.action({
				op:'setNeeds', 
				product_id: hits[0].product_id, 
				needs: needs+1
			})			
		}
	}

	render() {
		const { core } = this.props
		
		var actionButton = null
		
		if (core.productFilter) {
		
			const hits = core.products.filter(p => {
					if (core.productFilter == '*') return true
					return p.name.toLowerCase().indexOf(core.productFilter.toLowerCase()) >= 0
				})

			if (hits.length == 0) {
				actionButton = <span className="clickable" id="filter-action" title="add product">+</span>
			}		
			else if (hits.length == 1) {
				actionButton = <span className="clickable" id="filter-action" title="add one unit">+1 </span>
			}
			
		}
		
		return <span id="filter">
			<input onChange={this.updateFilter} onKeyDown={this.keyPress} value={core.productFilter} ref={(input) => { this.filterInput = input }}  />
			{actionButton}
		</span>
		
	}
	
}


